import type { Partner } from '@/mocks/site';

interface PartnerPortraitProps {
  partner: Partner;
  variant: number;
}

const FRAGMENTS = [
  ['b', 'q', '\u00a7', '7', 'e'],
  ['%', 'h', 'd', '3', '\u2116'],
  ['k', 'e', '9', 'b', '\u00b6'],
  ['g', '0', 'n', '\u2211', 'b'],
];

const FRAG_POS = [
  'left-[12%] top-[18%]', 'left-[20%] top-[34%]', 'right-[14%] top-[14%]', 'right-[10%] top-[30%]', 'left-[8%] top-[50%]',
];

export default function PartnerPortrait({ partner, variant }: PartnerPortraitProps) {
  const dotted = variant % 2 === 0;
  const frags = FRAGMENTS[variant % FRAGMENTS.length];

  return (
    <div className="relative aspect-square w-full overflow-hidden">
      {/* semicircular archival backdrop */}
      <div
        className={`absolute inset-x-[6%] bottom-0 top-[4%] overflow-hidden rounded-t-full bg-background-200/80 ${dotted ? 'halftone' : 'halftone halftone-soft'}`}
      />
      {/* type fragments */}
      {frags.map((f, i) => (
        <span
          key={`${f}-${i}`}
          aria-hidden="true"
          className={`absolute ${FRAG_POS[i]} font-label text-[13px] text-foreground-700/70 md:text-[15px]`}
        >
          {f}
        </span>
      ))}
      {/* portrait */}
      <div className="absolute inset-x-[16%] bottom-0 top-[8%]">
        <img
          src={partner.image}
          width={600}
          height={720}
          decoding="async"
          fetchPriority={variant < 2 ? 'high' : 'auto'}
          alt={`${partner.name}, ${partner.role} at AVENOR`}
          title={`${partner.name} — ${partner.focus}`}
          className="archival-img h-full w-full bg-transparent object-cover object-top"
        />
      </div>
      {/* oversized red letter */}
      <span
        aria-hidden="true"
        className="absolute bottom-[-6%] right-[4%] select-none font-poster text-[24vw] font-extrabold leading-[0.8] text-primary-500 mix-blend-multiply sm:text-[20vw] lg:text-[11vw] 2xl:text-[170px]"
      >
        {partner.letter}
      </span>
    </div>
  );
}